<template>
  <div class="category-container">
    <pageTitle>一级经销商信息管理</pageTitle>

    <div class="main">
      <el-button type="primary" plain @click="addFirstAgentDialog=true">添加一级经销商信息</el-button>
      <el-dialog title="新增一级经销商信息" :visible.sync="addFirstAgentDialog">
        <el-form :model="addFirstAgentData" ref="addFirstAgentData"
                 :rules="addFirstAgentRules"
                 label-width="200px">
          <el-form-item label="姓名" prop="first_agent_name">
            <el-input v-model="addFirstAgentData.first_agent_name"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="first_agent_address">
            <el-input v-model="addFirstAgentData.first_agent_address"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="first_agent_phone">
            <el-input v-model="addFirstAgentData.first_agent_phone"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="first_agent_company">
            <el-input v-model="addFirstAgentData.first_agent_company"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFirstAgentDialog = false">取 消</el-button>
          <el-button type="primary" @click="addFirstAgent('addFirstAgentData')">确 定</el-button>
        </div>
      </el-dialog>


      <div class="categoryList">
        <el-table :data="firstAgentListData" stripe style="width:100%;margin-bottom: 35px;">
          <el-table-column width="160px" prop="first_agent_name" label="姓名"></el-table-column>
          <el-table-column width="300px" prop="first_agent_address" label="地址"></el-table-column>
          <el-table-column width="200px" prop="first_agent_phone" label="联系方式"></el-table-column>
          <el-table-column width="280px" prop="first_agent_company" label="公司名称"></el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column width="180px" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" plain
                         @click.native.prevent="editorFirstAgentItemDataDialog(scope.$index, scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


      <el-dialog title="编辑一级经销商信息" :visible.sync="editorFirstAgentDialog">
        <el-form :model="editorFirstAgentData" ref="editorFirstAgentData"
                 :rules="addFirstAgentRules"
                 label-width="200px">
          <el-form-item label="姓名" prop="first_agent_name">
            <el-input v-model="editorFirstAgentData.first_agent_name"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="first_agent_address">
            <el-input v-model="editorFirstAgentData.first_agent_address"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="first_agent_phone">
            <el-input v-model="editorFirstAgentData.first_agent_phone"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="first_agent_company">
            <el-input v-model="editorFirstAgentData.first_agent_company"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editorFirstAgentDialog = false">取 消</el-button>
          <el-button type="primary" @click="editorFirstAgent('editorFirstAgentData')">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import pageTitle from "../components/pageTitle";

export default {
  name: "firstAgent",
  components: {
    pageTitle
  },
  data() {
    return {
      //添加一级经销商数据
      addFirstAgentData: {},
      //添加一级经销商数据验证规则
      addFirstAgentRules: {
        first_agent_name: [
          {required: true, message: '请输入一级经销商用户名', trigger: 'blur'},
        ],
        first_agent_address: [
          {required: true, message: '请输入一级经销商地址', trigger: 'blur'},
        ],
        first_agent_phone: [
          {required: true, message: '请输入一级经销商联系方式', trigger: 'blur'},
        ],
        first_agent_company: [
          {required: true, message: "请输入一级经销商密码", trigger: "blur"}
        ],
      },

      //一级经销商列表数据
      firstAgentListData: null,

      //添加一级经销商数据模态框
      addFirstAgentDialog: false,

      //编辑一级经销商数据
      editorFirstAgentData: {},
      //编辑一级经销商数据模态框
      editorFirstAgentDialog: false
    }
  },
  methods: {
    //获取公司数据
    getFirstAgentListData() {
      this.axios.post('agentInfo/getFirstAgentList').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          this.firstAgentListData = success.data.data
        }
      })
    },

    //添加一级经销商
    addFirstAgent(firstAgentData) {
      this.$refs[firstAgentData].validate((valiResult) => {
        if (valiResult) {
          this.axios.post('agentInfo/addFirstAgent', this.addFirstAgentData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '添加一级经销商信息成功'
              })
              this.getFirstAgentListData()
              this.addFirstAgentDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //编辑一级经销商
    editorFirstAgent(firstAgentData) {
      this.$refs[firstAgentData].validate((valiResult) => {
        if (valiResult) {

          this.axios.post('agentInfo/updateFirstAgent', this.editorFirstAgentData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '编辑一级经销商信息成功'
              })
              this.getFirstAgentListData()
              this.addFirstAgentDialog = false
              this.editorFirstAgentDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //打开编辑模态框
    editorFirstAgentItemDataDialog(index, row) {
      this.editorFirstAgentDialog = true
      this.editorFirstAgentData = {
        id: row.id,
        first_agent_name: row.first_agent_name,
        first_agent_address: row.first_agent_address,
        first_agent_phone: row.first_agent_phone,
        first_agent_company: row.first_agent_company,
      }
    }
  },
  created() {
    this.getFirstAgentListData()
  }
}
</script>

<style scoped lang="scss">

.category-container {

  .main {
    margin-left: 10px;

    .categoryList {
      margin-top: 30px;

      ul {
        border-radius: 5px;
        overflow: hidden;

        li {
          list-style: none;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #707070;
          background-color: #DCDFE6;

          label {
            float: left;
            margin-left: 20px;
          }

          .el-button {
            float: right;
            margin-top: 5px;
            margin-right: 10px;
          }
        }

        li:hover {
          background-color: #c0c4cc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/firstAgent.vue